module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-right-6.324105a5.png";